import ResetPassword from '../../auth/components/reset-password/ResetPassword';

export default function ResetPasswordPage() {
    return <ResetPassword />;
}
